export enum ScanType {
  RODO = 'RODO',
  OFI = 'OFI'
}
